import AudioPlayer from './AudioPlayer'
export * from './AudioPlayer'
export default AudioPlayer
